import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';

const css = `
  .container-scroller {
    overflow: hidden;
  }
  
  .page-body-wrapper.full-page-wrapper {
    width: 100%;
    min-height: 100vh;
    padding-top: 0;
  }
  
  .page-body-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    padding-left: 0;
    padding-right: 0;
  }
  
  .content-wrapper {
    background: #f4f5f7;
    padding: 1.5rem 2.5rem;
    width: 100%;
    flex-grow: 1;
  }
  
  .auth .auth-form-light {
    background: #ffffff;
    padding: 3rem 2rem !important;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }
  
  .click_here_to_login_btn {
    background-color: #744587;
    border-color: #744587;
    color: #fff !important;
    padding: 10px 24px;
    font-weight: 500;
    border-radius: 6px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
  }
  
  .click_here_to_login_btn:hover {
    background-color: #22a3d7;
    border-color: #22a3d7;
  }
  
  .logout_content {
    text-align: center;
  }
  
  .logout_content img {
    width: 140px;
    height: auto;
    margin-bottom: 1.5rem;
  }
  
  .logout_content h4 {
    color: #333333;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .logout_content h6 {
    font-weight: 400 !important;
    color: #666666;
    line-height: 1.6;
  }

  .contact-link {
    color: #744587;
    text-decoration: none;
    transition: color 0.2s ease;
  }

  .contact-link:hover {
    color: #22a3d7;
    text-decoration: underline;
  }

  .contact-row {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    margin-bottom: 6px;
    font-size: 14px;
    color: #444;
  }

  .contact-row:last-child {
    margin-bottom: 0;
  }

  .contact-icon {
    font-size: 15px;
    flex-shrink: 0;
  }
`;

class unauthorizedAccess extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.navigateLogIn = this.navigateLogIn.bind(this);
  }

  navigateLogIn() {
    this.props.navigate('/');
    sessionStorage.clear();
    localStorage.clear();
  }

  render() {
    return (
      <>
        <div className="container-scroller" style={{ overflow: 'hidden' }}>
          <div className="container-fluid page-body-wrapper full-page-wrapper">

            <div className="content-wrapper d-flex flex-column align-items-center justify-content-center auth px-3">

              {/* Top Disclaimer Ticker */}
              <div className="w-100 mb-4" style={{ maxWidth: '500px' }}>
                <marquee
                  style={{ fontSize: "14px", color: "#555", fontWeight: "500" }}
                  behavior="scroll"
                  direction="left"
                  scrollamount="4"
                  onMouseOver={(e) => e.target.stop()}
                  onMouseOut={(e) => e.target.start()}
                >
                  <span>
                    <b>Disclaimer and Ownership:</b> All content, including text, graphics, images, and other
                    materials on this website and associated online application systems/accounts, is the exclusive
                    property of India ITME Society or is used under appropriate license. Unauthorized copying,
                    reproduction, distribution, publication, display, modification, creation of derivative works,
                    transmission, or any other form of exploitation of this content is strictly prohibited without
                    prior written consent from the copyright owner. Any violation of these terms will result in
                    immediate legal action and enforcement of intellectual property rights.
                  </span>
                </marquee>
              </div>

              {/* Main Card */}
              <div className="w-100" style={{ maxWidth: '480px' }}>
                <div className="auth-form-light">
                  <div className="logout_content d-flex flex-column align-items-center justify-content-center">

                    {/* Logo */}
                    <img src="assets/img/logo_white.png" alt="ITME Logo" />

                    <h3 className="mb-2" style={{ fontSize: "1.8rem", fontWeight: "700", color: "#dc3545" }}>
                      Unauthorised Access
                    </h3>

                    <hr className="w-100 my-3" style={{ borderTop: "1px solid #e9ecef" }} />

                    <h4>ITME Trade Services</h4>
                    <p className="text-muted px-2 mb-4" style={{ fontSize: "15px" }}>
                      You are not authorised to access this page.<br />
                      Kindly reach out to the ITME Team.
                    </p>

                    {/* Contact Details Block */}
                    <div
                      className="p-3 mb-4 w-100 rounded text-center"
                      style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}
                    >
                      <h6 className="font-weight-bold mb-3 text-dark" style={{ fontSize: "14px" }}>
                        Contact Details
                      </h6>

                      {/* Phone 1 */}
                      <div className="contact-row">
                        <a href="tel:+912249724603" className="contact-link">
                          +91-22-4972 4603
                        </a>
                      </div>

                      {/* Phone 2 — Registration Queries */}
                      <div className="contact-row">
                        <span>
                          <a href="tel:+919920822645" className="contact-link">
                            +91-9920 8226 45
                          </a>
                          <span className="text-muted ms-1" style={{ fontSize: "12px" }}>
                            (Registration Queries)
                          </span>
                        </span>
                      </div>

                      {/* Email */}
                      <div className="contact-row">
                        <a href="mailto:business.desk@india-itme.com" className="contact-link">
                          business.desk@india-itme.com
                        </a>
                      </div>

                      {/* Website */}
                      <div className="contact-row">
                        <a
                          href="https://tradedesk.india-itme.com/"
                          className="contact-link"
                          target="_blank"
                          rel="noreferrer"
                        >
                          tradedesk.india-itme.com
                        </a>
                      </div>

                      {/* Social */}
                      <div className="contact-row">
                        <a
                          href="https://www.instagram.com/indiaitme2012"
                          className="contact-link"
                          target="_blank"
                          rel="noreferrer"
                        >
                          @indiaitme2012
                        </a>
                      </div>
                    </div>

                    {/* Back to Home Button */}
                    <button
                      type="button"
                      className="btn click_here_to_login_btn border-0 w-100"
                      onClick={this.navigateLogIn}
                    >
                      Back to Home
                    </button>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <ToastContainer />
        <style dangerouslySetInnerHTML={{ __html: css }} />
      </>
    );
  }
}

export default withRouter(connect(null, {})(unauthorizedAccess));